module.exports = __webpack_public_path__ + "static/media/LegoFFMountainMKingLivingRoomA0007_design_clean_v002.734d724a.png";